import { AppBar, Box, Button, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Tab, Tabs, Typography } from '@mui/material';
import React, {
    useEffect,
    useState
} from 'react'
import { Link, useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { vdrSingleCompanyAction, openPDFAction } from '../../redux/actions/VdrAction';

import { AiOutlineFilePdf } from "react-icons/ai";

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { DATA_20_YEARS_QUARTERLY_REQUEST, DATA_20_YEARS_REQUEST, PEER_TO_PEER_REQUEST, QUARTERLY_REVIEW_RESET, QUARTERLY_SEGMENT_RESET, VDR_SINGLE_COMPANY_REQUEST } from '../../constants/VdrConstants';

import {
    FORENSIC_TAB_SHOW_HIDE_REQUEST
} from '../../constants/userConstants';

import { Charts, DocumentView, FinancialCharts, LoadingComponent, MediaSection } from '../../components';

import { Link as SLink } from 'react-scroll'
import { decodeAtob, ideaTypeTitle, recommendationType, checkUser, loggedInUser } from '../../constants/helpers';
import SingleCompanyValuation from '../../components/SingleCompanyValuation/Index';
import styled from '@emotion/styled';
import MediaModel from '../../components/SingleCompanyContainer/MediaSection/MediaModel';
import moment from 'moment';
import ForensicComponent from '../components/ForensicComponent';
import { LOGO } from '../../images/images';



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            className="tabPanelParent"
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}


const CompanyDetail = () => {

    const dispatch = useDispatch();
    let { companyName } = useParams();
    // console.log(useParams());
    const { data: companyData, loading } = useSelector((state) => state.vdrSingleCompanyReducer);

    let companyId;
    // if (localStorage.getItem('single-company-data')) {
    //     companyId = decodeAtob(localStorage.getItem('single-company-data'));
    // }
    companyId = decodeAtob(companyName);
    // console.log(companyId);
    const [researchButton, setResearchButton] = React.useState([]);
    useEffect(() => {
        checkUser()
    }, [])
    useEffect(() => {
        window.scrollTo(0, 0)
        dispatch(vdrSingleCompanyAction({ CompanyID: companyId, token: '123', User_id: (loggedInUser?.user_id || 1037) }));
        dispatch({ type: 'ForensicReset' });
        dispatch({ type: QUARTERLY_SEGMENT_RESET });
        dispatch({ type: FORENSIC_TAB_SHOW_HIDE_REQUEST });
        dispatch({ type: QUARTERLY_REVIEW_RESET });
        dispatch({ type: DATA_20_YEARS_QUARTERLY_REQUEST });
        dispatch({ type: DATA_20_YEARS_REQUEST });
        dispatch({ type: PEER_TO_PEER_REQUEST });
    }, [dispatch, companyId])

    const theme = useTheme();


    const [value, setValue] = React.useState(0);
    const [value1, setValue1] = React.useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    if (loading) {
        return (
            <LoadingComponent />
        );
    }

    let ResearchTabArray = [
        "aboutUS",
        "bigPicture",
        "Promoters",
        "product",
        "price",
        "triggers",
        "risk",
        "Peers",
    ];

    let rightLabel = companyData.Company[0]?.companies?.company_type ? ideaTypeTitle(companyData.Company[0]?.companies?.company_type) : "";

    let rightRecommendation = companyData.Company[0]?.companies?.recommendation ? recommendationType(companyData.Company[0]?.companies?.recommendation).title : "";
    const companyData1 = companyData.Company[0]?.companies; 
    const mTabsArr = [
        {
            id:"0",
            name:"Reports",
        },
        {
            id:"1",
            name:"Valuation",
        },
        {
            id:"2",
            name:"Financial",
        },
        // {
        //     id:"3",
        //     name:"Technical Charts",
        // },
        {
            id:"4",
            name:"Media",
        },
        {
            id:"5",
            name:"Forensic",
        }
    ]

    return (
        <>

            <Box id="div1">
                <Box className='detailContainer' sx={{
                    // backgroundImage:'url(https://omkaradata.in/vdr_old/public/images/banner-details.jpg) !important'
                }} >
                    {/* <div className='detail-header' style={{ backgroundImage: 'url(https://omkaradata.in/vdr_old/public/images/banner-details.jpg' }}>

                    </div> */}

                    <Box
                        sx={{
                            zIndex: 1,
                            position: 'relative',
                            // marginTop: '-35vh',
                            padding: 2,
                        }}
                    >


                        <Box className='TopContainer' sx={{
                            marginTop: 7,
                            backgroundColor: '#fff',
                            padding: 3,
                            minHeight: '100vh'
                        }}>


                            {
                                companyData.Company ?
                                    <>

                                        <Box className='categoryContainer'>

                                            <Box>
                                                <Box className='mobLogoContainer'>
                                                    <img
                                                        src={companyData.Company[0]?.companies?.logo ? companyData.Company[0]?.companies?.logo : LOGO}
                                                    />
                                                </Box>
                                                <Box className='titleContainer'>
                                                    <Typography variant="h4"  >
                                                        {companyData.Company[0]?.companies.company_name}
                                                    </Typography>
                                                    <Box>
                                                        <div>
                                                            <span>
                                                                <Typography variant='body' fontSize={20} fontWeight="500">₹ {companyData.Company[0]?.companies?.price_row?.price}</Typography>
                                                            </span>
                                                            <span style={{ color: companyData.Company[0]?.companies?.price_row?.color }}>
                                                                <div style={{ display: 'inherit' }}>
                                                                    {
                                                                        companyData.Company[0]?.companies?.price_row.arrow_type == 1 ?
                                                                            <>
                                                                                <ArrowUpwardIcon sx={{ fontSize: 20, marginTop: '0.3rem', position: 'relative', top: '0.2rem' }} />
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <ArrowDownwardIcon sx={{ fontSize: 20, marginTop: '0.3rem', }} />
                                                                            </>
                                                                    }
                                                                    {companyData.Company[0]?.companies?.price_row?.differencepercentage}%
                                                                </div>
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <Typography variant='body' >{companyData.Company[0]?.companies?.price_row?.priceDate ? moment(companyData.Company[0]?.companies?.price_row?.priceDate, 'DD-MM-YYYY HH:mm:ss', true).format('DD-MMM-YYYY HH:mm:ss') : null}</Typography>
                                                        </div>
                                                    </Box>

                                                </Box>
                                                {/* <Box display="flex" className='afterTitle'>
                                                    {
                                                        rightRecommendation
                                                            ?
                                                            <Box
                                                                sx={{ marginRight: '0.5rem' }}
                                                            >
                                                                <Typography variant='contained' >Recommendation: <span style={{ color: recommendationType(companyData.Company[0]?.companies?.recommendation).color, fontWeight: 'bold' }}>{rightRecommendation}</span></Typography>
                                                            </Box>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        rightLabel
                                                            ?
                                                            <>
                                                                <Typography variant='contained' color="success" className='pipeDivider'>|</Typography>
                                                                <Box
                                                                    sx={{ marginLeft: '0.5rem' }}
                                                                >
                                                                    <Typography variant='contained' color="success">Idea Type: <b>{rightLabel}</b></Typography>
                                                                </Box>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </Box> */}
                                                {/* <Box display="flex" className='afterTitle' fontSize={13}>
                                                    {
                                                        companyData1?.recommendation_price
                                                            ?
                                                            <Box
                                                                sx={{ marginRight: '0.5rem' }}
                                                            >
                                                                <Typography variant='contained' color="success"> Reco. Date: <b>{companyData1?.recommendation_date ? moment(companyData1?.recommendation_date).format('DD MMM YYYY') : null }</b></Typography>
                                                            </Box>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        companyData1?.recommendation_date
                                                            ?
                                                            <>
                                                                <Typography variant='contained' color="success" className='pipeDivider'>|</Typography>
                                                                <Box
                                                                    sx={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
                                                                >
                                                                <Typography variant='contained' > Reco. Price: ₹ <span style={{ fontWeight: '600' }}>{companyData1?.recommendation_price}</span></Typography>
                                                                    
                                                                </Box>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        companyData1?.recommendation_Difference
                                                            ?
                                                            <>
                                                                <Typography variant='contained' color="success" className='pipeDivider'>|</Typography>
                                                                <Box
                                                                    sx={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
                                                                >
                                                                    <Typography variant='contained'  >Change from Reco.: 
                                                                        <Typography variant='contained'   sx={{ 
                                                                            color: companyData1?.recommendation_Difference > 0 ? 'green' : 'red',fontWeight: 'bold',
                                                                            display: 'inline',
                                                                            marginLeft:'3px'
                                                                         }}>{
                                                                        companyData1?.recommendation_Difference > 0 ? companyData1?.recommendation_Difference + '%' : companyData1?.recommendation_Difference + '%'
                                                                    }</Typography>
                                                                    </Typography>
                                                                </Box>
                                                            </>
                                                            :
                                                            null
                                                    }
                                                </Box> */}
                                            </Box>

                                            <Box className='logoContainer'>
                                                <div>
                                                    <img
                                                        src={companyData.Company[0]?.companies?.logo ? companyData.Company[0]?.companies?.logo : LOGO}
                                                    />
                                                </div>
                                            </Box>
                                        </Box>

                                        <Box sx={{
                                            marginTop: 5
                                        }}>
                                            <Typography
                                                variant="body1"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        `${companyData.Company[0]?.companies?.about}`
                                                }}
                                            ></Typography>


                                        </Box>

                                    </>
                                    :
                                    null
                            }

                            <Divider sx={{ margin: '0.5rem 0' }} />
                            <Box sx={{
                                marginTop: 0
                            }} className="" >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="inherit"
                                    variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile
                                    aria-label="full width tabs example"
                                >
                                    {/* <Tab label="Research" {...a11yProps(0)} /> */}

                                    {
                                        mTabsArr.map((item, index00)=>{
                                            return (
                                                <Tab label={item?.name} {...a11yProps(index00)} /> 
                                            )
                                        })
                                    }
                                    {/* <Tab label="Reports" {...a11yProps(0)} />
                                    <Tab label="Financial" {...a11yProps(2)} />
                                    <Tab label="Technical Charts" {...a11yProps(3)} />
                                    <Tab label="Media" {...a11yProps(4)} />
                                    <Tab label="Forensic" {...a11yProps(5)} /> */}

                                    {/* <Tab label="Updates" {...a11yProps(2)} /> */}
                                </Tabs>

                                {/* {
                                    value === 0 ?

                                        <Box className='ResearchContainer' sx={{
                                            marginTop: "1.5rem"
                                        }}>

                                            {
                                                companyData.research.length > 0 ?

                                                    <>

                                                        {

                                                            Object.keys(companyData.research[0]).map((itemSingle) => {
                                                                const itemR = companyData.research[0];

                                                                if (itemSingle !== "$id") {
                                                                    if (itemR[itemSingle]?.Type !== null) {

                                                                        return (
                                                                            <>
                                                                                <SLink activeClass="active" className='ResearchButton' offset={-50} spy to={itemSingle} smooth={true} duration={1000} >
                                                                                    <Button sx={{
                                                                                        margin: '0 0.2rem 0',
                                                                                        // padding: '0.5rem 0 ',
                                                                                    }} variant="outlined" size="small" >
                                                                                        {itemR[itemSingle]?.Type}
                                                                                    </Button>
                                                                                </SLink>
                                                                            </>
                                                                        );

                                                                    }
                                                                }

                                                            })
                                                        }
                                                    </>
                                                    :
                                                    null
                                            }

                                        </Box>
                                        :
                                        null
                                } */}


                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    className="SwipeableViews"
                                >

                                    {/* <TabPanel value={value} index={0} dir={theme.direction}
                                        className="SwipeableView111s">

                                        <Box className='ResearchBody'>

                                            {
                                                companyData.research && companyData.research.length ?

                                                    <>

                                                        {

                                                            Object.keys(companyData.research[0]).map((itemSingle) => {
                                                                const itemR = companyData.research[0];

                                                                if (itemSingle !== "$id") {
                                                                    if (itemR[itemSingle]?.Type !== null) {

                                                                        return (
                                                                            <>
                                                                                <Box id={itemSingle} sx={{
                                                                                    marginBottom: 2
                                                                                }}>
                                                                                    <Typography variant='h6'>
                                                                                        {itemR[itemSingle]?.Type}
                                                                                    </Typography>
                                                                                    <Typography variant='body1'
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html:
                                                                                                `${itemR[itemSingle]?.Description}`
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            </>
                                                                        );
                                                                    }
                                                                }

                                                            })
                                                        }
                                                    </>
                                                    :

                                                    <Typography variant="h6">To be Updated</Typography>
                                            }
                                        </Box>

                                    </TabPanel> */}

                                    <TabPanel value={value} index={0} dir={theme.direction}>

                                        {
                                            companyData.Data ?
                                                <>
                                                    <DocumentView companyData={companyData && companyData?.Data}  allData={companyData && companyData} />
                                                </>
                                                :
                                                null
                                        }
                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>

                                        {
                                            companyData.valuationTable ?
                                                <>
                                                    <SingleCompanyValuation valuationTable={companyData && companyData?.valuationTable} />
                                                </>
                                                :
                                                null
                                        }

                                    </TabPanel>
                                    <TabPanel value={value} index={2} dir={theme.direction}>

                                        {
                                            companyData.valuationTable ?
                                                <>
                                                    <FinancialCharts companyId={companyId} technicalData={companyData && companyData?.technical} />
                                                </>
                                                :
                                                null
                                        }

                                    </TabPanel>
                                    {/* <TabPanel value={value} index={3} dir={theme.direction}>

                                        {
                                            companyData.valuationTable ?
                                                <>
                                                    <Charts technicalData={companyData && companyData?.technical} />
                                                </>
                                                :
                                                null
                                        }

                                    </TabPanel> */}
                                    <TabPanel value={value} index={3} dir={theme.direction}>

                                        {
                                            companyData.valuationTable ?
                                                <>
                                                    {/* <Typography variant="h6">Coming Soon</Typography> */}
                                                    <MediaSection CompanyID={companyId} />

                                                    {/* <Charts valuationTable={companyData && companyData?.valuationTable} /> */}
                                                </>
                                                :
                                                null
                                        }

                                    </TabPanel>
                                    
                                    <TabPanel value={value} index={4} dir={theme.direction}>
                                        <ForensicComponent dataFor="vdr" />
                                    </TabPanel>
                                </SwipeableViews>
                            </Box>

                        </Box>
                    </Box>
                    <MediaModel />
                </Box>
            </Box>

            {/* <div>{companyName}</div>
        <div>{companyId}</div> */}
        </>
    )
}

export default CompanyDetail